/* WeQuote Dev Board — global card search (Lee, 27 Aug).
 * One search box on every screen. Matches ANYTHING on the card: id/number,
 * title, notes, progress/design notes, comments, checklist items, requester
 * companies & people, customer reach, initiative, dev (slug + display name),
 * status (key + label), priority/effort/time labels, links, archive reason,
 * source. Multi-word queries: every word must match somewhere on the card.
 * Ranked: exact id → title hits → everything else, then priority order. */
import type { Feature } from './types'
import { DL, PL, EL, timeLabel, statusLabels } from './constants'

export function searchHaystack(f: Feature): string {
  const parts: (string | undefined)[] = [
    '#' + f.id, String(f.id), f.title, f.notes, f.pnotes, f.designNotes,
    f.cust, f.init, f.archiveReason,
    f.dev, f.dev ? DL[f.dev] : '', f.status, statusLabels()[f.status],
    f.pri, PL[f.pri], f.eff, EL[f.eff], f.time ? timeLabel(f.time) : '',
    f.isBug ? 'bug' : '',
  ]
  ;(f.requests || []).forEach((r) => { parts.push(r.company, r.person) })
  ;(f.comments || []).forEach((c) => { parts.push(c.author, c.text) })
  ;(f.checklist || []).forEach((c) => parts.push(c.text))
  ;(f.links || []).forEach((l) => { parts.push(l.label, l.url) })
  if (f.source) parts.push(f.source.by, f.source.company, f.source.person)
  return parts.filter(Boolean).join('   ').toLowerCase()
}

export interface SearchHit { feat: Feature; rank: number }

export function searchCards(fs: Feature[], query: string): SearchHit[] {
  const q = (query || '').trim().toLowerCase()
  if (!q) return []
  const words = q.split(/\s+/).filter(Boolean)
  const hits: SearchHit[] = []
  fs.forEach((f) => {
    const hay = searchHaystack(f)
    if (!words.every((w) => hay.indexOf(w) > -1)) return
    const title = (f.title || '').toLowerCase()
    const rank = String(f.id) === q || '#' + f.id === q ? 0 : words.some((w) => title.indexOf(w) > -1) ? 1 : 2
    hits.push({ feat: f, rank })
  })
  hits.sort((a, b) => a.rank - b.rank || a.feat.po - b.feat.po)
  return hits
}
